import type {ReactElement} from 'react';
import ContentBlock from '@components/CoverPage/ContentBlock/ContentBlock';
import Background from '@components/CoverPage/Background';
import Notification from '@components/CoverPage/Notification';
import {Trans} from '@lingui/macro';

export default function GenericErrorScreen(): ReactElement {
    return (
        <Background>
            <ContentBlock>
                <Notification>
                    <Trans>
                        Something went wrong, try refreshing the page. If the problem persists,
                        contact us at{' '}
                        <a href="mailto:team@actsofwriting.com">team@actsofwriting.com</a>
                    </Trans>
                </Notification>
            </ContentBlock>
        </Background>
    );
}
